import { ConferenceStatus } from './ConferenceStatus';

export class ConferenceReception {
  constructor(readonly status: ConferenceStatus) {}

  static empty(): ConferenceReception {
    return new ConferenceReception(ConferenceStatus.OutOfConference);
  }
}
